import { Story } from '../../types/story';

export const parisTutor: Story = {
  id: 'paris-tutor',
  title: 'Conjugating Desire',
  excerpt: 'French lessons in the Marais take an unexpected turn when grammar becomes foreplay.',
  city: 'Paris',
  publishDate: '2025-12-12',
  readTime: '17 min read',
  tags: ['♀♂', 'tutor', 'language', 'dominant'],
  categories: ['intense', 'forbidden'],
  intensity: 3,
  content: `I hired Étienne to teach me French. What he actually taught me was something else entirely.

I'd moved to Paris for work—a six-month contract that required "conversational French," which I absolutely did not have. My company recommended a tutor, and Étienne's profile looked perfect: native speaker, literature degree from the Sorbonne, five-star reviews.

What his profile didn't mention was that he was devastatingly attractive.

He showed up at my apartment in the Marais on a Tuesday evening—tall, lean, with dark hair and the kind of face that belonged in a French New Wave film. He wore a black turtleneck and jeans, and when he shook my hand, his grip was firm and warm.

"Bonsoir," he said. "Je m'appelle Étienne."

"Hi. I'm—"

"En français, s'il vous plaît."

"Je m'appelle... Claire?"

He smiled. "Bon. We begin."

The first few lessons were torture. Not because French is hard—though it is—but because I couldn't concentrate. Étienne had a way of looking at me when I spoke, like he was listening to more than just my words. His corrections were gentle but firm, and when he leaned close to demonstrate pronunciation, I could smell his cologne—something expensive and subtle.

"Your mouth is too tense," he said during our third lesson. We were working on vowel sounds, and I kept getting them wrong. "French requires... softness. Relaxation."

"I'm trying."

"Try harder." He reached out, his fingers touching my jaw. "Here. You're holding tension here."

His touch was professional, clinical even. But my body didn't care about professional. My body cared that a beautiful French man was touching my face and telling me to relax my mouth.

"Better," he said, pulling back. "Again. 'Je voudrais.'"

"Je voudrais."

"Non. Listen." He said it again, slower. "Je voudrais. I want. Do you hear the difference?"

"I think so."

"What do you want, Claire?"

The question hung in the air. We both knew he was asking about more than French verbs.

"To learn," I said carefully.

"Good. Then let's continue."

By the fourth lesson, the tension was unbearable. We were sitting on my couch, working through conjugations, and every time he leaned over to correct something in my notebook, I could feel the heat of him.

"You're distracted," he observed.

"I'm not."

"You are. You've written the same verb three times incorrectly." He closed my notebook. "What's distracting you?"

I could've lied. Should've lied. Instead, I said, "You."

He didn't look surprised. "I know."

"You know?"

"You think I don't notice? The way you look at me? The way your breathing changes when I'm close?" He shifted closer. "I'm a tutor, Claire. Not blind."

"I'm sorry. I'll find someone else—"

"I didn't say I minded." His hand touched my knee. "But we should address it. This tension—it's affecting your learning."

"How do you suggest we address it?"

"I have an idea." His eyes were dark, intense. "But it requires trust. And honesty. Can you do that?"

"Yes."

"Then tell me. What do you want?"

My mouth was dry. "You."

"En français."

"Je te veux."

"Better. And what do you want me to do?"

This was insane. This was my French tutor. This was completely unprofessional.

"Touch me," I whispered.

"En français."

"Touche-moi."

He smiled. "Très bien."

His hand slid up my thigh, slow and deliberate. "We're going to continue your lesson. But with new rules. You answer in French, you get rewarded. You answer in English, you get punished. Compris?"

"Oui."

"Good girl." His hand reached the hem of my skirt. "Now. Conjugate vouloir. Present tense."

"Je veux, tu veux, il veut—" I gasped as his fingers brushed against my underwear. "Nous voulons, vous voulez—"

"Continue."

"Ils veulent."

"Perfect." He pushed my underwear aside, his fingers finding me wet and ready. "You're very good at following instructions."

He worked me slowly, his fingers circling my clit, building pressure but never quite enough. Every time I got close, he'd stop and ask another question.

"Passé composé of faire."

"J'ai fait, tu as fait—fuck—"

He stopped. "English. That's a punishment."

"No, please—"

"En français."

"S'il te plaît—"

"Better." He resumed, slower this time. "Try again."

"J'ai fait, tu as fait, il a fait, nous avons fait, vous avez fait, ils ont fait."

"Excellent." He added a second finger, pushing inside me. "You learn so much better like this."

He was right. My brain was on fire, split between French grammar and the overwhelming sensation of his fingers inside me. Every correct answer brought me closer to the edge, every mistake pulled me back.

"Subjunctive of être."

"Que je sois, que tu sois, qu'il soit—" I moaned as his thumb found my clit. "Que nous soyons, que vous soyez, qu'ils soient."

"Parfait." He increased his pace. "Come for me, Claire. But you have to ask in French."

"Je peux—" I gasped. "Je peux jouir?"

"Oui. Maintenant."

I came hard, my body clenching around his fingers, French and English both forgotten in the moment.

He withdrew his hand slowly, brought his fingers to his mouth, and licked them clean. "Delicious. And your French is improving."

I was still trying to catch my breath. "That was—"

"Effective?" He smiled. "I told you. Immersion is the best way to learn."

"Is this how you teach all your students?"

"Just the ones who look at me the way you do." He stood up. "Same time next week?"

"Wait. What about you?"

"What about me?"

"Don't you want—"

"This lesson was about you. Next lesson will be about me." He picked up his bag. "Practice your conjugations. I'll test you."

He left, and I sat there on my couch, still trembling, wondering what the hell had just happened.

The next lesson, he made good on his promise.

"On your knees," he said as soon as he arrived.

I obeyed.

"We're going to work on your oral skills." He unbuckled his belt. "And I do mean oral."

He taught me French vocabulary I'd never find in a textbook. Taught me how to say "harder" and "slower" and "just like that" in a language that made everything sound like poetry. Taught me that learning could be pleasure and pleasure could be learning.

Our lessons became something else entirely. We'd start with grammar, move to vocabulary, and end with him fucking me on every surface of my apartment while quizzing me on verb tenses.

"Imparfait of aimer," he'd say, his hips snapping forward.

"J'aimais, tu aimais—" I'd gasp.

"Continue."

By the end of six months, my French was fluent. My company was impressed. My coworkers wanted to know my secret.

I told them I had an excellent tutor.

On my last day in Paris, Étienne came over for our final lesson. We didn't bother with books.

"I'm going to miss you," I said afterward, lying in his arms.

"En français."

"Tu vas me manquer."

"Tu vas me manquer aussi." He kissed my forehead. "But you don't need me anymore. Your French is perfect."

"Maybe I need you for other reasons."

"Maybe you do." He pulled me closer. "Paris isn't going anywhere. Neither am I."

I extended my contract. Then extended it again. Eventually, I stopped pretending I was staying for work.

Because sometimes a French tutor teaches you more than just language. Sometimes conjugating verbs becomes foreplay. Sometimes Paris isn't just a city—it's the place where you learn that the best lessons are the ones that leave you breathless.

And sometimes, "je t'aime" is the only phrase you really need to know.`
};
